/**
 * Format number as VND currency using Intl.NumberFormat vi-VN
 */
export function formatVnd(value: number): string {
  return (
    new Intl.NumberFormat('vi-VN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number.isFinite(value) ? value : 0) + ' đ'
  );
}

/**
 * Compact format for chart/labels (e.g. 1.2M đ)
 */
export function formatVndCompact(value: number): string {
  const v = Number.isFinite(value) ? value : 0;
  if (v >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1)}B đ`;
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M đ`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(0)}k đ`;
  return formatVnd(v);
}
